import React from 'react';
import { Labeled, List, ShowButton, Show, SimpleShowLayout, Datagrid, TextField, ReferenceField } from 'react-admin';
import JsonField from './JsonField';

export const InfoList = (props) => (
  <List {...props} bulkActions={false}>
    <Datagrid>
      <TextField source="id" />
      <ReferenceField label="Auth" source="auth_id" reference="auth" linkType="show">
        <TextField source="uuid" />
      </ReferenceField>
      <TextField source="label" />
      <ShowButton />
    </Datagrid>
  </List>
);

const LabelField = (props) => {
  const label = props.record['label'];

  switch (label) {
    case 'salesforce': {
      const { id } = props.record.data;
      return <a href={`https://tpt.lightning.force.com/lightning/r/Contact/${id}/view`} target="_blank" rel="noopener noreferrer">{label}</a>;
    }

    default:
      return <span>{label}</span>;
  }
};

export const InfoShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <ReferenceField label="Auth" source="auth_id" reference="auth" linkType="show">
        <TextField source="uuid" />
      </ReferenceField>
      <Labeled label="Label">
        <LabelField />
      </Labeled>
      <Labeled label="Data">
        <JsonField source="data" />
      </Labeled>
      <TextField source="created_at"/>
      <TextField source="updated_at"/>
    </SimpleShowLayout>
  </Show>
);

export const InfoReferences = (props) => {
  return <Datagrid {...props}>
    <TextField source="id"/>
    <ReferenceField label="Site" source="user_id" reference="user">
      <TextField source="domain" />
    </ReferenceField>
    <LabelField label="Label" />
    <JsonField source="data"/>
    <TextField source="created_at"/>
    <TextField source="updated_at"/>
    <ShowButton />
  </Datagrid>;
};


// WEBPACK FOOTER //
// ./resources/assets/js/info.js